export default __webpack_public_path__ + "static/media/amex-ico.084aae10.svg";